import MyStorage from "../storage";

window.appListe = null;
window.calendarsShown = 0;
window.calendarsCount = 0;

window.initBaseAppFrontend = function() {

    const $baseApp = $('#baseApp, .baseminiapp');
    let idInt = 100;

    if ($baseApp.length > 0) {

        $baseApp.each(function () {
            let curId = $(this).attr('id');
            let tipoLista = 'appListe'; // default utilizzato esempio nelle recensioni medici in lista e in pagina medico / clinica

            if (!curId) {
                //generate a rondom id
                curId = 'baseApp' + idInt;
                $(this).attr('id', curId);
                tipoLista = curId;
            }

            if(tipoLista == 'appListe') {
                if (window.appListe) {
                    // console.log('exiting', tipoLista, curId);
                    // console.groupEnd();
                    return true;
                }
            }

            //console.log('init', tipoLista, curId);

            window[tipoLista] = new Vue({
                el: '#' + curId,
                data: {
                    configApp: typeof configApp === 'undefined' ? {} : configApp,
                },
                mounted:function () {
                },
                computed: {

                },
                watch: {

                },
                methods: {
                    goTo: function(path,replaceState) {
                        const url = new URL(window.location);
                        if (path.indexOf('http') < 0 && path.substring(0, 1) != '/') path = '/'+path;
                        if (replaceState) {
                            window.location.replace=url.origin+path;
                            return;
                        }
                        if(path.indexOf('http') >= 0) {
                            return window.location.href=path;
                        }

                        window.location.href=url.origin+path;
                    },
                    loadScript(urlScript, callback) {
                        let d = document, t = 'script',
                            o = d.createElement(t),
                            s = d.getElementsByTagName(t)[0];
                        o.src =  urlScript;
                        if (callback) { o.addEventListener('load',  (e) => { callback(e); }, false); }
                        s.parentNode.insertBefore(o, s);
                    },
                    loadStyle(urlScript, callback) {
                        let d = document, t = 'link',
                            o = d.createElement(t),
                            s = d.getElementsByTagName(t)[0];
                        o.href =  urlScript;
                        o.rel="stylesheet";
                        if (callback) { o.addEventListener('load',  (e) => { callback(e); }, false); }
                        s.parentNode.insertBefore(o, s);
                    },

                    getCittaByProvincia: function(id) {
                        return new Promise((resolve,reject) => {
                            if (!id) reject();
                            httpRequest(api_url+'cittaProvincia/'+id,{}).then(onResult => {
                                if (onResult.result) {
                                    resolve(onResult.data.citta);
                                } else {
                                    reject();
                                }
                            });
                        });

                    },

                    getProvincie: function() {
                        return new Promise((resolve,reject) => {
                            httpRequest(api_url+'provincie',{}).then(onResult => {
                                if (onResult.result) {
                                    resolve(onResult.data.provincie);
                                } else {
                                    reject();
                                }
                            });
                        });

                    },

                    getNazioni: function() {
                        return new Promise((resolve,reject) => {
                            httpRequest(api_url+'nazioni',{}).then(onResult => {
                                if (onResult.result) {
                                    resolve(onResult.data.nazioni);
                                } else {
                                    reject();
                                }
                            });
                        });
                    },

                    getQueryParams: function(key) {
                        if (!key || typeof key != 'string') return;
                        let uri = window.location.search.substring(1);
                        let params = new URLSearchParams(uri);
                        return params.getAll(key);
                    }
                }
            });
            // console.log('End Calendar ' + curId);
            // window.calendarsCount++;
            idInt++;
    });
    // console.log('total count', window.calendarsCount);
    // console.groupEnd();
}
}
